import React from 'react'
import CountrySelect from './CountrySelect'
import MultiSelect from './MultiSelect'
import { without } from 'lodash'

interface MultiCountrySelectProps {
  values: string[]
  onChange: (newValues: string[]) => void
}

export default function MultiCountrySelect({ values, onChange }: MultiCountrySelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="Countries"
      values={values.map((v) => (
        <span key={v}>{v}</span>
      ))}
      select={
        <CountrySelect
          multi
          itemDisabled={(item) => values.includes(item)}
          onChange={(country) =>
            onChange(values.includes(country) ? without(values, country) : [...values, country])
          }
          value={null}
          btnText="Add"
          {...{ buttonProps }}
        />
      }
      onRemove={(v) => onChange(values.filter((av) => av !== v))}
    />
  )
}
